"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppPortalAccessIn = void 0;
class AppPortalAccessIn {
    constructor() {
    }
    static getAttributeTypeMap() {
        return AppPortalAccessIn.attributeTypeMap;
    }
}
exports.AppPortalAccessIn = AppPortalAccessIn;
AppPortalAccessIn.discriminator = undefined;
AppPortalAccessIn.attributeTypeMap = [
    {
        "name": "expiry",
        "baseName": "expiry",
        "type": "number",
        "format": "uint64"
    },
    {
        "name": "featureFlags",
        "baseName": "featureFlags",
        "type": "Array<string>",
        "format": ""
    }
];
//# sourceMappingURL=AppPortalAccessIn.js.map